import { useApi } from '@equifinance/shared';

const apiPath = `${process.env.REACT_APP_BROKER_MANAGEMENT_API_AUTH_PATH}/`;

const apiUrl = (path: string) => `${apiPath}${path}`;

export type SetupPasswordRequest = {
  token: string;
  emailAddress: string;
  password: string;
}

export function useSetupPasswordApi() {
  const { post } = useApi(apiUrl);

  return {
    post: (payload: SetupPasswordRequest): Promise<Record<string, any>> => post('user/validate-registration-token', payload),
  };
}
